import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/";

export const getAssignments = (token) =>
  axios.get(`${API_URL}assignments/`, {
    headers: { Authorization: `Token ${token}` },
  });

export const getAssignment = (token, assignmentId) =>
  axios.get(`${API_URL}assignments/${assignmentId}/`, {
    headers: { Authorization: `Token ${token}` },
  });
